import React, { forwardRef, type Ref } from 'react';
import { type BaseFieldProps } from './base-field-props';
import { Field } from '../field';
import { useFieldProps } from '../../contexts/field-props-context';

interface BaseErrorProps {
  asChild?: boolean;
  className?: string;
}

const BaseErrorRoot = <T extends BaseFieldProps>(
  props: BaseErrorProps,
  ref: Ref<HTMLDivElement>,
) => {
  const { errorMessage } = useFieldProps<T>();

  return (
    <Field.Error ref={ref} {...props}>
      {errorMessage}
    </Field.Error>
  );
};

export const BaseError = forwardRef(BaseErrorRoot) as typeof BaseErrorRoot;
